import { WiStars } from "react-icons/wi";

const CtaPage = () => {
  return (
    <div>
      <section className="overflow-hidden bg-gray-50 sm:grid sm:grid-cols-2 sm:items-center mb-20">
        {/* Image on the left */}
        <img
          alt=""
          src="/image/demo.gif"
          className="h-full w-full object-cover sm:h-[calc(100%_-_2rem)] sm:self-end sm:rounded-se-[30px] md:h-[calc(100%_-_4rem)] md:rounded-se-[60px]"
        />

        {/* Text on the right */}
        <div className="p-8 md:p-12 lg:px-16 lg:py-24">
          <div className="mx-auto max-w-xl text-left">
            <h2 className="text-3xl font-bold sm:text-5xl mb-10 text-left">
              AI-Powered PTE Learning with Real-Time Feedback
            </h2>

            <p className="hidden text-gray-500 md:mt-4 md:block text-lg">
              Unlock smarter PTE preparation with personalized study plans,
              AI-powered learning paths, and real-time feedback tailored to your
              performance. Whether you're working on speaking, writing, reading,
              or listening, PrepNexis helps you focus on your weak areas and
              accelerate your improvement.
            </p>

            <div className="mt-4 md:mt-8">
              <a
                href="/signup"
                className="mt-8 hidden sm:inline-block rounded bg-gradient-to-r from-gray-600 via-gray-800 to-gray-900  px-12 py-3 text-sm font-medium text-white transition hover:bg-gray-800 focus:outline-none focus:ring focus:ring-yellow-400 flex  hover:scale-105 items-center justify-center gap-4"
              >
                <WiStars className="w-5 h-5 inline-block" />
                <span className="inline-block px-2">Try For Free</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CtaPage;
